import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Event } from '@/types';

export const getEvents = (eventId: number): Promise<Event[]> => {
  return axios.get(`/${eventId}/event/all`);
};

type QueryFnType = typeof getEvents;

type UseEventsOptions = {
  eventId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useEvents = ({ config, eventId }: UseEventsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['events', eventId],
    queryFn: () => getEvents(eventId),
    ...config,
  });
};
